'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _assets = require('../../utils/assets');

var _locationLink = require('../basic-report-row/components/location-link');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Single source of truth for the CSV schema.
 *
 * Every row is normalised against this list before it leaves getCsvData, and
 * the same list is handed to CSVLink's `headers` prop. That means the column
 * order is identical for every campaign, regardless of which platforms happen
 * to appear in the data or which order the posts arrive in.
 *
 * To add a column: add it here and set it in the relevant branch of buildRow.
 * Branches that don't produce it will emit an empty cell automatically.
 */
var CSV_COLUMNS = [{ key: 'channel', label: 'channel' }, { key: 'influencer', label: 'influencer' }, { key: 'influencerName', label: 'Influencer Name' }, { key: 'influencer_link', label: 'influencer_link' }, { key: 'date', label: 'date' }, { key: 'post_type', label: 'post_type' }, { key: 'asset_link', label: 'asset_link' }, { key: 'caption', label: 'caption' }, { key: 'followerCount', label: 'followerCount' }, { key: 'mentions', label: 'mentions' }, { key: 'hashtags', label: 'hashtags' }, { key: 'impressions', label: 'impressions' }, { key: 'views', label: 'views' }, { key: 'reach', label: 'reach' }, { key: 'isReel', label: 'isReel' }, { key: 'isIGTV', label: 'isIGTV' }, { key: 'likes', label: 'likes' }, { key: 'comments', label: 'comments' }, { key: 'reactions', label: 'reactions' }, { key: 'engagements', label: 'engagements' }, { key: 'saved', label: 'saved' }, { key: 'shares', label: 'shares' }, { key: 'username', label: 'username' },
// Appended to the right so the columns above keep the agreed order.
// clicks: VK / Blog / Snapchat only. stickerTaps: stories with supporting data.
{ key: 'clicks', label: 'clicks' }, { key: 'stickerTaps', label: 'stickerTaps' },
// Tagged Instagram place, posts and stories only.
{ key: 'location', label: 'location' }, { key: 'location_id', label: 'location_id' }, { key: 'location_link', label: 'location_link' }];

var getLocationColumns = function getLocationColumns(location) {
  return {
    location: _lodash2.default.get(location, 'name', ''),
    location_id: _lodash2.default.get(location, 'id', ''),
    location_link: (0, _locationLink.getLocationUrl)(location)
  };
};

var safeSum = function safeSum(object, fields) {
  // NOTE: this was `let sum;`, which made the first `sum += v` produce NaN and
  // poisoned every subsequent addition, so the engagements column was always
  // blank. Starting at 0 is the fix.
  var sum = 0;

  _lodash2.default.forEach(fields, function (f) {
    var v = _lodash2.default.get(object, f, 0);
    sum += v;
  });

  return sum || '';
};

var replaceHash = function replaceHash(text) {
  return _lodash2.default.replace(text, /\n/g, '%23');
};
var replaceNumberSign = function replaceNumberSign(text) {
  return _lodash2.default.replace(text, /#/g, '');
};

var safeDescription = function safeDescription(text) {
  var safe = _lodash2.default.replace(text, /\n/g, ' ');
  safe = replaceHash(safe);
  safe = replaceNumberSign(safe);
  return _lodash2.default.truncate(safe, { length: 500 }) || '';
};

var getHandle = function getHandle(post) {
  if (post.type === 'stories') {
    return post.attributes.username;
  }
  switch (_lodash2.default.get(post, 'trackedAsset.platform')) {
    case 'YOUTUBE':
      return post.channelTitle;
    case 'TWITTER':
      return post.twitterHandle;
    case 'FACEBOOK':
      return post.facebookHandle || post.influencerName;
    case 'INSTAGRAM':
      return post.instagramHandle || post.influencerName;
    default:
      return null;
  }
};

/*
 * `influencer` is the platform handle; this is the person's real name where we
 * hold it. Posts carry it at the top level, stories under attributes.
 */
var getInfluencerName = function getInfluencerName(post) {
  return _lodash2.default.get(post, 'influencerName') || _lodash2.default.get(post, 'attributes.influencerName') || _lodash2.default.get(post, 'trackedAsset.influencerName') || '';
};

/*
 * Previously the default branch hardcoded an instagram.com URL for every
 * platform, so YouTube/Twitter/Facebook rows got a link built from a channel
 * title or a Twitter handle. YouTube returns nothing because channelTitle is a
 * display name, not a URL slug.
 */
var getInfluencerLink = function getInfluencerLink(post) {
  var handle = getHandle(post);

  if (!handle) {
    return '';
  }

  switch (_lodash2.default.get(post, 'trackedAsset.platform')) {
    case 'INSTAGRAM':
      return 'https://www.instagram.com/' + handle;
    case 'TWITTER':
      return 'https://twitter.com/' + handle;
    case 'FACEBOOK':
      return 'https://www.facebook.com/' + handle;
    default:
      return '';
  }
};

var buildRow = function buildRow(p) {
  //
  if (_lodash2.default.get(p, 'platform') === 'VK' || _lodash2.default.get(p, 'platform') === 'BLOG' || _lodash2.default.get(p, 'platform') === 'SNAPCHAT') {
    return {
      channel: _lodash2.default.get(p, 'platform'),
      influencer: _lodash2.default.get(p, 'discussionName'),
      influencerName: getInfluencerName(p),
      date: _lodash2.default.get(p, 'createdDate'),
      post_type: _lodash2.default.get(p, 'assetType'),
      asset_link: _lodash2.default.get(p, 'assetURL'),
      views: (0, _assets.getSupportingDataField)(_lodash2.default.get(p, 'supportingData', []), 'views'),
      likes: (0, _assets.getSupportingDataField)(_lodash2.default.get(p, 'supportingData', []), 'likes'),
      clicks: (0, _assets.getSupportingDataField)(_lodash2.default.get(p, 'supportingData', []), 'clicks'),
      comments: (0, _assets.getSupportingDataField)(_lodash2.default.get(p, 'supportingData', []), 'comments'),
      shares: (0, _assets.getSupportingDataField)(_lodash2.default.get(p, 'supportingData', []), 'shares'),
      caption: safeDescription(_lodash2.default.get(p, 'extraData.text')),
      impressions: '',
      reach: '',
      username: _lodash2.default.get(p, 'discussionName'),
      followerCount: _lodash2.default.get(p, 'followerCount')
    };
  }
  //
  if (p && p.platform && p.platform === 'TIKTOK') {
    var initialData = p.initialData,
        tiktokData = p.tiktokData;

    var latestTiktokData = _lodash2.default.last(_lodash2.default.sortBy(tiktokData, 'createdDate')) || initialData;
    return {
      channel: 'TIKTOK',
      influencer: _lodash2.default.get(p, 'discussionName'),
      influencerName: getInfluencerName(p) || _lodash2.default.get(p, 'initialData.authorMeta.nickName', ''),
      influencer_link: 'https://www.tiktok.com/@' + _lodash2.default.get(p, 'discussionName'),
      date: _lodash2.default.get(p, 'createdDate'),
      post_type: _lodash2.default.get(p, 'assetType'),
      asset_link: _lodash2.default.get(p, 'assetURL'),
      caption: safeDescription(_lodash2.default.get(p, 'initialData.text')),
      views: _lodash2.default.get(latestTiktokData, 'playCount', ''),
      likes: _lodash2.default.get(latestTiktokData, 'diggCount', ''),
      comments: _lodash2.default.get(latestTiktokData, 'commentCount', ''),
      shares: _lodash2.default.get(latestTiktokData, 'shareCount', ''),
      impressions: '',
      reach: '',
      username: _lodash2.default.get(p, 'discussionName'),
      followerCount: _lodash2.default.get(p, 'initialData.authorMeta.fans')
    };
  }

  if (p.type === 'stories') {
    var _p$attributes = p.attributes,
        storyData = _p$attributes.storyData,
        assetType = _p$attributes.assetType;

    var latestData = _lodash2.default.last(storyData);
    var _supportingData = _lodash2.default.get(p, 'relationships.supportingData.data');

    var _latestSupportingData = void 0;

    if (_supportingData && _supportingData.length) {
      var filtered = _lodash2.default.filter(_supportingData, 'attributes.createdDate'); // remove the GraphQL null at [0]
      var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
        return _lodash2.default.get(o, 'attributes.createdDate');
      }));
      _latestSupportingData = ordered[0];
    }

    var _data = (0, _extends3.default)({
      channel: 'INSTAGRAM',
      influencer: p.attributes.username,
      influencerName: getInfluencerName(p),
      influencer_link: 'https://www.instagram.com/' + p.attributes.username,
      username: p.attributes.username,
      date: latestData.createdDate,
      post_type: 'STORY',
      asset_link: p.attributes.assetURL,
      caption: safeDescription(p.attributes.caption),
      followerCount: _lodash2.default.get(p, 'followerCount'),
      mentions: p.attributes.mentions,
      hashtags: safeDescription(p.attributes.hashtags)
    }, getLocationColumns(p.attributes.location));

    _lodash2.default.assign(_data, {
      impressions: _lodash2.default.get(_latestSupportingData, 'attributes.impressions', latestData.impressions),
      views: assetType === 'VIDEO' ? _lodash2.default.get(_latestSupportingData, 'attributes.views', latestData.impressions) : '',
      reach: _lodash2.default.get(_latestSupportingData, 'attributes.reach', latestData.reach)
    });

    return _data;
  }

  var stats = p.latestStatistic;
  var insights = _lodash2.default.get(stats, 'insights');
  var supportingData = _lodash2.default.get(p, 'trackedAsset.supportingData');

  var latestSupportingData = void 0;

  if (supportingData && supportingData.length) {
    var _filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
    var _ordered = _lodash2.default.reverse(_lodash2.default.sortBy(_filtered, function (o) {
      return o.createdDate;
    }));
    latestSupportingData = _ordered[0];
  }

  var postType = p.isVideo ? 'VIDEO' : 'IMAGE';

  if (_lodash2.default.get(p, 'trackedAsset.assetType') === 'STORY') {
    postType = 'STORY';
  }

  var handle = safeDescription(getHandle(p));

  var data = (0, _extends3.default)({
    channel: _lodash2.default.get(p, 'trackedAsset.platform'),
    influencer: handle,
    influencerName: safeDescription(getInfluencerName(p)),
    influencer_link: getInfluencerLink(p),
    username: handle,
    followerCount: _lodash2.default.get(p, 'followerCount'),
    date: p.publishedDate || _lodash2.default.get(p, 'trackedAsset.publishedDate', ''),
    post_type: postType,
    asset_link: _lodash2.default.get(p, 'trackedAsset.assetURL'),
    caption: safeDescription(p.text),
    isReel: p.isReel || '',
    isIGTV: p.isIGTV || ''
  }, getLocationColumns(_lodash2.default.get(p, 'trackedAsset.location')));

  if (_lodash2.default.get(p, 'trackedAsset.createdSource', '') === 'CAMPAIGN') {
    _lodash2.default.set(data, 'caption', safeDescription(p.text));
  }

  if (stats) {
    _lodash2.default.assign(data, {
      views: stats.playCount || stats.viewCount || stats.openCount || '',
      likes: stats.likeCount || '',
      comments: stats.commentCount || '',
      reactions: stats.reactionCount || '',
      engagements: safeSum(stats, ['viewCount', 'likeCount', 'commentCount', 'reactionCount'])
    });
  }

  if (insights) {
    _lodash2.default.assign(data, {
      impressions: insights.totalVideoImpressions || insights.impressions || '',
      reach: insights.totalVideoImpressionsUnique || insights.reach || '',
      saved: insights.saved || ''
    });
  }

  if (latestSupportingData) {
    _lodash2.default.assign(data, {
      impressions: latestSupportingData.impressions || '',
      reach: latestSupportingData.reach || '',
      saved: latestSupportingData.saves || '',
      engagements: latestSupportingData.engagements || '',
      shares: latestSupportingData.shares || '',
      stickerTaps: latestSupportingData.stickerTaps || ''
    });
  }

  if (!data.reach) {
    _lodash2.default.assign(data, { reach: _lodash2.default.get(p, 'latestInsights.reach', 0) });
  }

  if (!data.impressions) {
    _lodash2.default.assign(data, { impressions: _lodash2.default.get(p, 'latestInsights.impressions', 0) });
  }

  return data;
};

/*
 * Projects a row onto CSV_COLUMNS so that every object has exactly the same
 * keys in exactly the same order. Missing and null values become empty cells
 * rather than disappearing, which is what used to shift the columns around.
 */
var normaliseRow = function normaliseRow(row) {
  return _lodash2.default.fromPairs(_lodash2.default.map(CSV_COLUMNS, function (_ref) {
    var key = _ref.key;

    var value = _lodash2.default.get(row, key);
    return [key, _lodash2.default.isNil(value) ? '' : value];
  }));
};

var getCsvData = function getCsvData(posts) {
  return _lodash2.default.map(posts, function (p) {
    return normaliseRow(buildRow(p));
  });
};

module.exports = {
  getCsvData: getCsvData,
  CSV_COLUMNS: CSV_COLUMNS
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/basic-report/csv-generator.js
 ** module id = 2618
 ** module chunks = 0
 **/